<template>
  <div class="display-1 mb-3 text-center">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FhTitle'
}
</script>

<style scoped>

</style>
